var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-container",
    { attrs: { fluid: "" } },
    [
      _c("admin-preloader", { attrs: { show: _vm.loading } }),
      _vm._v(" "),
      _c("admin-breadcrumb", {
        attrs: {
          items: [
            { text: "Pricing Plans", path: { name: "admin-pricing-plans" } },
          ],
          name: _vm.pricingPlan ? _vm.pricingPlan.name : "Edit Pricing Plan",
          "no-title": "",
        },
      }),
      _vm._v(" "),
      !_vm.loading
        ? _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { lg: "4", md: "5" } },
                [
                  _c(
                    "admin-panel",
                    { attrs: { "sub-title": "Companies" } },
                    [
                      _vm.companies.length
                        ? _c("admin-companies-table", {
                            attrs: {
                              companies: _vm.companies,
                              "pricing-plan-view": "",
                            },
                          })
                        : _c("h4", { staticClass: "mb-0" }, [
                            _vm._v("No companies connected to this plan"),
                          ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "admin-panel",
                    { attrs: { "sub-title": "Delete Pricing Plan" } },
                    [
                      _c("h4", { staticClass: "mb-2" }, [
                        _vm._v("Warning:"),
                        _c("br"),
                        _vm._v(
                          "After confirmation this action cannot be reversed"
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "no-permission-wrapper",
                        { attrs: { show: !_vm.canDeletePricingPlans } },
                        [
                          _c(
                            "b-btn",
                            {
                              attrs: {
                                variant: "danger",
                                disabled: !_vm.canDeletePricingPlans,
                              },
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  return _vm.confirmDeletePricingPlan.apply(
                                    null,
                                    arguments
                                  )
                                },
                              },
                            },
                            [_vm._v("\n            Delete Plan\n          ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { lg: "8", md: "7" } },
                [
                  _c(
                    "admin-panel",
                    {
                      attrs: {
                        "with-footer": "",
                        "sub-title": "Edit Pricing Plan Data",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "footer",
                            fn: function () {
                              return [
                                _c(
                                  "no-permission-wrapper",
                                  {
                                    attrs: { show: !_vm.canUpdatePricingPlans },
                                  },
                                  [
                                    _c(
                                      "b-btn",
                                      {
                                        attrs: {
                                          variant: "primary",
                                          disabled:
                                            _vm.formState.processing ||
                                            !_vm.canUpdatePricingPlans,
                                        },
                                        on: {
                                          click: function ($event) {
                                            $event.preventDefault()
                                            return _vm.submitPricingPlan.apply(
                                              null,
                                              arguments
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n              Update Plan\n              "
                                        ),
                                        _vm.formState.processing
                                          ? _c("b-spinner", {
                                              staticClass: "ml-1",
                                              attrs: { small: "" },
                                            })
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        false,
                        851061824
                      ),
                    },
                    [
                      _c("admin-pricing-plan-form", {
                        attrs: {
                          validation: _vm.formValidation,
                          disabled: !_vm.canUpdatePricingPlans,
                        },
                        model: {
                          value: _vm.formData,
                          callback: function ($$v) {
                            _vm.formData = $$v
                          },
                          expression: "formData",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.pricingPlan
        ? _c(
            "b-modal",
            {
              ref: "deleteModal",
              attrs: {
                id: "delete-plan-modal",
                title: "Please confirm",
                centered: "",
                "ok-title": "Confirm",
                "ok-variant": "success",
              },
              on: { ok: _vm.deletePricingPlan },
            },
            [
              _c("h4", [_vm._v("You are going to delete this pricing plan")]),
              _vm._v(" "),
              _vm.pricingPlan.companies_count > 0
                ? [
                    _c("hr"),
                    _vm._v(" "),
                    _c(
                      "b-form-group",
                      {
                        attrs: { label: "Switch Companies to Different Plan" },
                      },
                      [
                        _c(
                          "b-form-checkbox",
                          {
                            model: {
                              value: _vm.switchCompaniesPlan,
                              callback: function ($$v) {
                                _vm.switchCompaniesPlan = $$v
                              },
                              expression: "switchCompaniesPlan",
                            },
                          },
                          [_vm._v("Yes")]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.switchCompaniesPlan
                      ? _c(
                          "b-form-group",
                          { attrs: { label: "Select Plan to Switch" } },
                          [
                            _c("b-form-select", {
                              attrs: {
                                options: _vm.planToSwitchOptions,
                                state: _vm.planToSwitchError ? false : null,
                              },
                              model: {
                                value: _vm.planToSwitch,
                                callback: function ($$v) {
                                  _vm.planToSwitch = $$v
                                },
                                expression: "planToSwitch",
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "b-form-invalid-feedback",
                              {
                                attrs: {
                                  state: _vm.planToSwitchError ? false : null,
                                },
                              },
                              [
                                _vm._v(
                                  "\n          " +
                                    _vm._s(_vm.planToSwitchError) +
                                    "\n        "
                                ),
                              ]
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]
                : _vm._e(),
            ],
            2
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }